module.exports = __webpack_public_path__ + "img/icon-bank.c664ea8a.svg";